import { createGlobalStyle } from "styled-components"
import "@fontsource/fira-sans"
import "@fontsource/fira-sans/600.css"
import "@fontsource/fira-sans/800.css"

const GlobalStyles = createGlobalStyle`
  :root {
    --red: #cc091f; 
    --background: #f2f2f2;
    --footer : #595959;
  }


/*------------------------------------*\
    BASICS
\*------------------------------------*/

 
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

html,
body {
    height: 100%;
    scroll-behavior: smooth;
}

html {
    font-size: 62.5%;
    text-rendering: geometricPrecision;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body {
    color: var(--font);
    font-family: "Fira Sans";
    font-size: 14px;
    line-height: 1.618;
}

body.no-scrolling {
  overflow: hidden;
  height: 100vh;
}

main {
  max-width: 100vw;
}


img {
  width: 100%;
  max-width: 700px;
}


a {
    color: inherit;
    text-decoration: none;
    outline: none;
}



h1,
h2,
h3,
h4
 {
  font-family: "Fira Sans";
    font-weight: 600;
    font-size: 2.5rem;
    color: var(--headline);
    line-height: 1;
    padding: 1rem 0;
}

h3,
h4
 {
  font-family: "Fira Sans";
  font-style: italic;
    font-weight: 600;
    font-size: 2rem;
    color: var(--headline);
    line-height: 1;
    padding: 1rem 0;
}




input {
    margin-right: 10px
}

audio {
    outline: none;
}

/*------------------------------------*\
    HELPER
\*------------------------------------*/
.top-space {
    margin-top: 3rem;
}

.body-grid {
    display: grid;    
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr auto;
    min-height: 100vh;
}

.small-print {
  font-style: italic;
font-size: 1.2rem;
}

nav ul li a.active {
  color: var(--red);
}

nav ul li a.active:hover {
  color: white;
}



/*------------------------------------*\
    SUBMENU
\*------------------------------------*/


.sub-menu {
  opacity: 0;
  position: absolute;
  left: 0;
  transition: 0.3s;
  pointer-events: none;
  width: 300px;
  padding-bottom: 1rem;
  
}

.sub-menu li {
  margin: 0;
  padding-right: 1.5rem;
  color: black;
  background-color: var(--background);
}

.sub-menu li:first-child {
    margin-top: 1rem;
}

.navigation ul li {
  position: relative;
  cursor: pointer;
}

.navigation ul li:hover > .sub-menu,
.sub-menu:hover {
  opacity: 1;
  height: 20px;
  pointer-events: inherit;
}

/*------------------------------------*\
    TRANSITIONS
\*------------------------------------*/


/*------------------------------------*\
    HAMBURGER
\*------------------------------------*/


.hamburger {
  z-index: 16;
  padding: 15px 15px;
  position: relative;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible; }
  .hamburger:hover {
    opacity: 0.7; }
  .hamburger.is-active:hover {
    opacity: 0.7; }
  .hamburger.is-active .hamburger-inner,
  .hamburger.is-active .hamburger-inner::before,
  .hamburger.is-active .hamburger-inner::after {
    background-color: #000; }

.hamburger-box {
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative; }

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px; }
  .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
    width: 35px;
    height: 3px;
    background-color: #000;
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease; }
  .hamburger-inner::before, .hamburger-inner::after {
    content: "";
    display: block; }
  .hamburger-inner::before {
    top: -10px; }
  .hamburger-inner::after {
    bottom: -10px; }

    .hamburger--slider .hamburger-inner {
  top: 2px; }
  .hamburger--slider .hamburger-inner::before {
    top: 9px;
    transition-property: transform, opacity;
    transition-timing-function: ease;
    transition-duration: 0.15s; }
  .hamburger--slider .hamburger-inner::after {
    top: 18px; }

.hamburger--slider.is-active .hamburger-inner {
  transform: translate3d(0, 10px, 0) rotate(45deg); }
  .hamburger--slider.is-active .hamburger-inner::before {
    transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
    opacity: 0; }
  .hamburger--slider.is-active .hamburger-inner::after {
    transform: translate3d(0, -20px, 0) rotate(-90deg); }



`

export default GlobalStyles
